var map = {
	"./br/pre_bg.png": 196,
	"./en/pre_bg.png": 71487,
	"./fr/pre_bg.png": 45088,
	"./ge/pre_bg.png": 37308,
	"./la/pre_bg.png": 21407,
	"./tw/pre_bg.png": 16265,
	"./zh/pre_bg.png": 36962
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7353;